<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.committee.title"></sm-page-header>
  <div class="content">
    <div class="flex justify-end gap-2 mb-4">
      <p-button [label]="'settings.committee.actions.access_history' | translate" (click)="router.navigate(['/settings/committee/history'])" severity="info"/>
      <p-button [label]="'settings.committee.actions.access_conselliers_history' | translate" (click)="router.navigate(['/settings/committee/conselliers-history'])" severity="secondary"/>
    </div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
    <sm-dialog #dialog [dialog]="committeeDialog"></sm-dialog>
  </div>
</div>
